<template>
  <BaseSvg class="arrow-forwards-icon" viewBox="0 0 20 20" fill="none">
    <path
      d="M2.5 10L9.16666 10"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 4.1665L17.5 9.99984L10 15.8332L10 4.1665Z"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </BaseSvg>
</template>

<script>
import { BaseSvg } from '@clovyr/bed';

export default {
  name: 'ArrowForwardsIcon',
  components: {
    BaseSvg,
  },
};
</script>

<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/util';

.arrow-forwards-icon {
  @include util.size(util.rem(20), util.rem(20));
}
</style>
